import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { MY_FORMATS } from 'src/app/_models/moment-formats';
import { AutorizacionPresencialService } from 'src/app/_services/autorizacion-presencial.service';
import { EstudioService } from '../../estudio/estudio.service';
import { ReporteGeneralService } from '../reporte-general/reporte-general.service';
import { AsistenciaService } from '../_services/asistencia.service';
import * as moment from 'moment';

@Component({
  selector: 'lista-alumnos',
  standalone: false,
  templateUrl: 'lista-alumnos.component.html',
  styleUrls: ['lista-alumnos.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class ListaAlumnosComponent implements OnInit, AfterViewInit {
  _alumnos: MatTableDataSource<any>;
  _fechaSeleccionada;
  _tiposAsistencia: any[] = [];
  retardo;
  ausencia;
  enCasa;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  cursos: any;

  vista = 'novedades';
  displayedColumns = [];

  @Input()
  alumnos: any[];
  @Input()
  fecha;
  @Input()
  tiposAsistencia;

  addedAlumnos: any[] = [];

  onCloseDialog = new EventEmitter();
  saving: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public estudioService: EstudioService,
    public asistenciaService: AsistenciaService,
    private autorizacionPresencial: AutorizacionPresencialService,
    private customAlert: CustomAlertService,
    private snackBar: MatSnackBar,
    private reporteGeneralService: ReporteGeneralService) {
  }

  ngOnInit() {
    if (this.data != null) {
      this.tiposAsistencia = this.data.tiposAsistencia;
      this.vista = this.data.vista ? this.data.vista : this.vista;
      this._fechaSeleccionada = this.data.fecha;
      this.data.alumnos.map(al => {
        al['id'] = 0;
        if (al['asistencia'] === null) {
          al['asistencia'] = {
            alumnoID: al.alumno.id,
            fechaAsistencia: this._fechaSeleccionada,
            tipoID: 0,
            isPermiso: false,
            comentario: '',
            id: 0
          };
        }
      });
      this._alumnos = new MatTableDataSource<any>(this.data.alumnos);
      this._tiposAsistencia = this.data._tiposAsistencia;
    } else {
      this._fechaSeleccionada = this.fecha;
      this.alumnos.map(al => {
        al['id'] = 0;
        if (al['asistencia'] === null) {
          al['asistencia'] = {
            alumnoID: al.alumno.id,
            fechaAsistencia: this._fechaSeleccionada,
            tipoID: 0,
            isPermiso: false,
            comentario: '',
            id: 0
          };
        }
      });
      this._alumnos = new MatTableDataSource<any>(this.alumnos);
      this._tiposAsistencia = this.tiposAsistencia;
    }

    if (this._tiposAsistencia) {
      this.retardo = this._tiposAsistencia.find(el => {
        return el.codigo === 'R';
      });
      this.ausencia = this._tiposAsistencia.find(el => {
        return el.codigo === 'A';
      });
      this.enCasa = this._tiposAsistencia.find(el => {
        return el.codigo === 'PC';
      });
    }
    this.cursos = this.estudioService.getCursos(true);

    this.displayedColumns = this.vista === 'novedades' ?
      ['Alumno', 'Curso', 'Retardo', 'Ausencia', 'En casa',
        'Permiso', 'FechaInit', 'FechaFin', 'Observacion'] : ['Alumno', 'Curso', 'fecha'];
  }

  ngAfterViewInit() {
    this._alumnos.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'Alumno':
          return item.alumno.apellidosNombres;
        case 'Curso':
          return item.curso.nombre;
        default:
          return item[property];
      }
    };
    this._alumnos.sort = this.sort;
    this._alumnos.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        return key === 'alumno' ? currentTerm + data.alumno.apellidosNombres : key === 'curso' ?
          currentTerm + data.curso.id : currentTerm + data[key];
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      let resp = true;
      filter.split(' ').forEach(item => {
        const transformedFilter = item.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        resp = dataStr.indexOf(transformedFilter) !== -1;
      });
      return resp;
    };
    this._alumnos.paginator = this.paginator;
  }

  filtroTexto(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this._alumnos.filter = filterValue;
  }

  filtroCurso(filterValue: string) {
    filterValue = filterValue.toString().trim();
    this._alumnos.filter = filterValue;
  }

  setEstado(estado, element, tipo): void {
    this.saving = true;
    if (tipo.nombre !== 'fechaInicia' && tipo.nombre !== 'fechaFin') {
      if (tipo.id > 0) {
        if (estado) {
          element.asistencia.tipoID = tipo.id;
        } else {
          element.asistencia.tipoID = 0;
        }
      } else {
        element.asistencia.isPermiso = estado;
        element.asistencia.tipoID = element.asistencia.tipoID === 12 ? 0 : element.asistencia.tipoID;
      }
    } else {
      element.asistencia[tipo.nombre] = estado.value;
    }
    if (!estado && element.asistencia.tipoID === 0 && !element.asistencia.isPermiso && element.asistencia.id > 0) {
      this.asistenciaService.deleteAsistenciaAlumno(element.asistencia.id).subscribe(() => {
        this.reporteGeneralService.removeStudent(element);
        this.saving = false;
      });
    } else {
      if (tipo.nombre === 'fechaInicia') {
        element.asistencia.fechaAsistencia = estado.value;
      }
      if (tipo.nombre === 'fechaFin') {
        element.asistencia.fechaAsistenciaFin = estado.value;
      }




      const duracion: number = element.asistencia.fechaAsistenciaFin ?
        Math.ceil(
          moment.duration(moment(element.asistencia.fechaAsistenciaFin).diff(moment(element.asistencia.fechaAsistencia))).asDays())
        : 0;
      if (duracion > -1) {
        element.asistencia.duracion = duracion;
        delete element.asistencia.fechaAsistenciaFin;
        this.asistenciaService.setEstadoAsistencia(element.asistencia).subscribe(res => {
          const currAsistencia = this.asistenciaService.extractData(res);
          element.asistencia = currAsistencia.asistencia;
          this.reporteGeneralService.editStudent(element);
          this.saving = false;
        });
      } else {
        this.customAlert.setCustomMessage({
          tipo: 'error',
          texto: `La fecha inicial debe ser anterior a la final. Por favor elija una fecha adecuada.`
        });
      }
    }
  }

  sub;

  setComentario(element) {
    this.saving = true;

    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this.asistenciaService.setEstadoAsistencia(element.asistencia).subscribe(res => {
      let currAsistencia = this.asistenciaService.extractData(res),
        indice = this.addedAlumnos.findIndex(el => {
          return el.asistencia.id === currAsistencia.asistencia.id;
        });
      if (indice !== -1) {
        this.addedAlumnos[indice] = currAsistencia;
      } else {
        element.asistencia.id = currAsistencia.asistencia.id;
        this.reporteGeneralService.editStudent(element);
      }
      this.saving = false;
    });
  }

  closeDialog() {
    this.onCloseDialog.emit(this.addedAlumnos);
  }

  guardarAutorizacion(fecha, element) {
    this.autorizacionPresencial.crearAutorizacion(element.alumno, fecha).subscribe(respuesta => {
      this.reporteGeneralService.addStudent(respuesta);
      this.snackBar.open('Autorización creada', null, { duration: 2500 });
    },
      err => {
        this.customAlert.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible crear la autorización. ${err.error}. <br> Código de error: ${err.statusText}`
        });
      });
  }

}
